import type { UserPageResponseContentItem } from './userPageResponseContentItem';
import type { UserPageResponseSort } from './userPageResponseSort';

export interface UserPageResponse {
  content?: UserPageResponseContentItem[];
  /** 첫 페이지 여부 */
  first?: boolean;
  /** 마지막 페이지 여부 */
  last?: boolean;
  /** 현재 페이지 번호 */
  number?: number;
  /** 현재 페이지의 요소 수 */
  numberOfElements?: number;
  /** 페이지 크기 */
  size?: number;
  sort?: UserPageResponseSort;
  /** 전체 요소 수 */
  totalElements?: number;
  /** 전체 페이지 수 */
  totalPages?: number;
}
